<template>
  <div id="element-to-print">
    <section v-if="product" class="product-detail my-1 my-md-3 p-0">
      <div class="container">
        <div class="row">
          <div class="col-4 align-self-center" data-aos="fade-in">
            <template v-if="productImage">
              <div class="zoom-container">
                <img :src="base64Image" alt="Image: Product Spec Image" style="max-width: 100%" />
              </div>
            </template>
          </div>
          <div class="col-8">
            <div class="content" data-aos="fade-in">
              <h1 class="smaller" style="text-align: left">{{ product.title }}</h1>
              <template v-if="product.content">
                <div class="notes">
                  <h4>{{ product.content[0].name }}</h4>
                  <div v-html="product.content[0].value"></div>
                </div>
              </template>

              <h4>Product Details</h4>
              <div class="list">
                <dl v-for="(option, index) in product.category_options" :key="index">
                  <dt>{{ option.category.title }}</dt>
                  <dd>{{ option.name }}</dd>
                </dl>
              </div>

              <a v-if="enabled" v-on:click="download()" class="btn btn-outline-dark">Download sheet</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import html2pdf from "html-to-pdf-js";
  import axios from 'axios'

  export default {
    name: 'ProductSpec',
    components: {

    },
    data() {
      return {
        product: null,
        enabled: true,
        productImage: null
      };
    },
    computed: {
      base64Image: function(){
        return 'data:' + this.product.images[0].mime_type + ';base64, ' + this.productImage
      }
    },
    methods: {
      loadProduct: function (product) {
        this.product = product;

        if(product.images.length > 0 ){
          this.getBase64Image()
        }
      },
      getBase64Image: function () {
       let url = this.product.images[0].url;

        axios.get(url, {
          responseType: 'arraybuffer'
        }).then(response => {
            this.productImage = Buffer.from(response.data, 'binary').toString('base64')
        })
      },
      download: function () {
        this.enabled = false;
        const slug = this.product.slug;
        var element = document.getElementById('element-to-print');

        var opt = {
          margin: 1,
          filename: slug + '.pdf',
          image: {type: 'jpeg', quality: 0.98},
          html2canvas: {scale: 2},
          jsPDF: {unit: 'pt', format: 'letter', orientation: 'portrait'}
        };

        html2pdf().set(opt).from(element).save();

        setTimeout(function() {
            location.reload()
          }, 2000
        )
      }
    }
  }
</script>
